var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "cabininput" };
var _hoisted_2 = { class: "paragraph-note--sm" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = {
    id: "selectedPassengersCabin",
    class: "paragraph-body"
};
var _hoisted_5 = {
    key: 0,
    class: "text--bold"
};
var _hoisted_6 = {
    key: 1,
    class: "text--bold"
};
var _hoisted_7 = { key: 2 };
var _hoisted_8 = { class: "base-model__content" };
var _hoisted_9 = { class: "base-model__header" };
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "base-model__header-title heading-h5" }, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "icon icon-alert-circle-colour icon--xs",
        "aria-hidden": "true"
    }),
    /*#__PURE__*/ _createTextVNode(" Important Information ")
], -1 /* HOISTED */);
var _hoisted_11 = ["onClick"];
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-close icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_13 = [
    _hoisted_12
];
var _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "base-model__body" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "rte" }, [
        /*#__PURE__*/ _createElementVNode("p", null, [
            /*#__PURE__*/ _createTextVNode("Children aged 5-15 traveling without an adult (18+) must book the Unaccompanied Minor service. Select passenger type based on age at the time of travel. This service is "),
            /*#__PURE__*/ _createElementVNode("strong", null, "NOT"),
            /*#__PURE__*/ _createTextVNode(" included in the ticket price and cannot be booked online.")
        ]),
        /*#__PURE__*/ _createElementVNode("p", null, [
            /*#__PURE__*/ _createTextVNode("Please "),
            /*#__PURE__*/ _createElementVNode("a", {
                href: "/en/plan/special-care/unaccompanied-minors",
                target: "_blank"
            }, "read more"),
            /*#__PURE__*/ _createTextVNode(" on how to reserve the Unaccompanied Minor service. By continuing you acknowledge that you've reviewed the terms. ")
        ])
    ])
], -1 /* HOISTED */);
var _hoisted_15 = { class: "base-model__footer" };
var _hoisted_16 = ["onClick"];
import { computed, inject, ref, watch } from 'vue';
import { defaultCabinInputValues } from './types';
import CabinInputContent from './CabinInputContent.vue';
import BaseModal from '../BaseModal/BaseModal.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CabinInput',
    props: {
        expandendVue: { type: Boolean, default: true },
        modelValue: { default: function (props) { var _a; return (_a = props.modelValue) !== null && _a !== void 0 ? _a : defaultCabinInputValues; } }
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var emits = _a.emit;
        var props = __props;
        var cmsProps = inject('cms-props');
        var isExpanded = ref(false);
        var inputValues = ref(props.modelValue);
        var tempInputValues = ref(props.modelValue);
        var resetValue = ref();
        var youthModal = ref(null);
        var errorMsg = ref('');
        var totalPassengers = computed(function () {
            return (tempInputValues.value.adults +
                tempInputValues.value.child +
                tempInputValues.value.youth);
        });
        var handleToggle = function () {
            isExpanded.value = !isExpanded.value;
            if (isExpanded.value) {
                resetValue.value = __assign({}, inputValues.value);
                window.addEventListener('click', windowClickHandler);
            }
            else {
                window.removeEventListener('click', windowClickHandler);
            }
        };
        var handleUpdateValues = function (key, value) {
            if (key === 'cabin') {
                tempInputValues.value[key] = value;
            }
            else if (typeof value === 'number') {
                tempInputValues.value[key] = value > 0 ? value : 0;
            }
            errorMesssageHandler();
        };
        var errorMesssageHandler = function () {
            var _a;
            errorMsg.value = '';
            switch (true) {
                case tempInputValues.value.adults === 0 &&
                    tempInputValues.value.youth !== 0:
                    // @ts-ignore
                    (_a = youthModal.value) === null || _a === void 0 ? void 0 : _a.openModal();
                    break;
                case tempInputValues.value.adults === 0 &&
                    tempInputValues.value.infant !== 0:
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Kindly choose at least one (1) adult. An infant cannot travel alone.';
                    break;
                case tempInputValues.value.adults < tempInputValues.value.infant:
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Kindly add more adult passengers. The number of infants traveling cannot exceed the number of adults.';
                    break;
                case tempInputValues.value.adults === 0 &&
                    tempInputValues.value.child !== 0:
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Kindly choose at least one (1) adult. A child cannot travel alone.';
                    break;
                case tempInputValues.value.adults === 0:
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Please select at least (1) passenger to continue.';
                    break;
                case tempInputValues.value.adults > 0 && (tempInputValues.value.child > 0 || tempInputValues.value.youth > 0 || tempInputValues.value.infant > 0):
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Select passenger type based on their age at the time of travel.';
                    break;
                case totalPassengers.value > 8:
                    errorMsg.value =
                        '<span class="text--bold">Please note: </span>Maximum of 9 passengers allowed, before it’s a group booking. To make a group booking of more than 9, please <a href="https://groups.kenya-airways.com/?_ga=2.228952606.306609538.1689137418-297987112.1683715296" target="_blank">click here</a>';
                    break;
                default:
                    break;
            }
        };
        var handleResetValues = function () {
            tempInputValues.value = __assign({}, resetValue.value);
            inputValues.value = __assign({}, resetValue.value);
        };
        var capitalizeFirstLetter = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };
        var windowClickHandler = function (e) {
            if (!e.target)
                return;
            var isTrigger = e.target.closest('.cabininput__trigger');
            var isContent = e.target.closest('.cabininput__content');
            if (!isTrigger && !isContent) {
                handleToggle();
            }
        };
        watch(tempInputValues, function () {
            errorMesssageHandler();
        });
        watch(function () { return props.modelValue; }, function (value) {
            inputValues.value = value;
            tempInputValues.value = value;
        }, { deep: true });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "cabininput__trigger",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                        "aria-controls": "cabininputContent",
                        onClick: handleToggle
                    }, [
                        _createElementVNode("p", _hoisted_2, [
                            _createTextVNode(_toDisplayString((_b = (_a = _unref(cmsProps)) === null || _a === void 0 ? void 0 : _a.passengersLabel.value) !== null && _b !== void 0 ? _b : 'Passengers') + " ", 1 /* TEXT */),
                            (_ctx.expandendVue)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/ " + _toDisplayString((_d = (_c = _unref(cmsProps)) === null || _c === void 0 ? void 0 : _c.cabinClassLabel.value) !== null && _d !== void 0 ? _d : 'Cabin class'), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("p", _hoisted_4, [
                            (tempInputValues.value.child +
                                tempInputValues.value.youth +
                                tempInputValues.value.infant ===
                                0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tempInputValues.value.adults) + " Adult ", 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tempInputValues.value.adults +
                                    tempInputValues.value.child +
                                    tempInputValues.value.youth) + " ", 1 /* TEXT */)),
                            (_ctx.expandendVue)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "in " + _toDisplayString(capitalizeFirstLetter(tempInputValues.value.cabin)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _createVNode(CabinInputContent, {
                        handleUpdateValues: handleUpdateValues,
                        isExpanded: isExpanded.value,
                        errorMsg: errorMsg.value,
                        totalPassengers: totalPassengers.value,
                        inputValues: tempInputValues.value,
                        toggleDropDown: handleToggle,
                        handleResetValues: handleResetValues
                    }, null, 8 /* PROPS */, ["isExpanded", "errorMsg", "totalPassengers", "inputValues"])
                ]),
                _createVNode(BaseModal, {
                    ref_key: "youthModal",
                    ref: youthModal
                }, {
                    "modal-content": _withCtx(function (_a) {
                        var closeModal = _a.closeModal;
                        return [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createElementVNode("button", {
                                        role: "button",
                                        "aria-label": "Dismiss modal",
                                        class: "button--text button--icon base-model__header-close",
                                        onClick: function () { closeModal(); }
                                    }, _hoisted_13, 8 /* PROPS */, _hoisted_11)
                                ]),
                                _hoisted_14,
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("button", {
                                        class: "button button--primary",
                                        onClick: function () { closeModal(); }
                                    }, "Okay", 8 /* PROPS */, _hoisted_16)
                                ])
                            ])
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
